import script from "./RacAssinaturaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RacAssinaturaPage.vue?vue&type=script&setup=true&lang=js"

import "./RacAssinaturaPage.vue?vue&type=style&index=0&id=5d49c674&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d49c674"]])

export default __exports__